// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"888b5878","952":"499edd77"}[chunkId] + ".chunk.js";
};